import { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import { ShopContext } from "../../context/ShopContext";

class Header extends Component {

  handleScroll = () => {
    const header = document.querySelector(".header-section");
    if (!header) return;

    if (window.scrollY > 200) {
      header.classList.add("header-fixed", "fadeInUp");
    } else {
      header.classList.remove("header-fixed", "fadeInUp");
    }
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  menuTrigger = () => {
    document.querySelector(".menu")?.classList.toggle("active");
    document.querySelector(".header-bar")?.classList.toggle("active");
  };

  menuTriggerTwo = () => {
    document.querySelector(".header-top")?.classList.toggle("open");
  };

  handleLogout = () => {
    const { setToken, navigate, setCartItems } = this.context;
    localStorage.removeItem("token");
    setToken("");
    setCartItems({});
    navigate("/login");
  };

  render() {
    const { getCartCount, token } = this.context;

    return (
      <header className="header-section">
        <div className="container">
          <div className="header-holder d-flex flex-wrap justify-content-between align-items-center">

            {/* LOGO */}
            <div className="logo">
              <Link to="/">
                <img
                  src="/assets/images/logo/F9-Logo.png"
                  alt="logo"
                  style={{ width: "90px", padding: "6px" }}
                />
              </Link>
            </div>

            <div className="header-menu-part">
              <div className="header-bottom">
                <div className="header-wrapper justify-content-lg-end">
                  <div className="menu-area">

                    {/* NAV MENU */}
                    <ul className="menu">
                      <li><NavLink to="/about">About</NavLink></li>
                      
                      <li><NavLink to="/shop">Shop</NavLink></li>
                      <li><NavLink to="/blog">Blog</NavLink></li>
                      <li><NavLink to="/contact">Contact</NavLink></li>
                    </ul>

                    {/* CART — ONLY WHEN LOGGED IN */}
                    {token && (
                      <Link to="/cart-page" className="cart-wrapper">
                        <img
                          src="/assets/images/logo/cart-icon.png"
                          alt="Cart"
                          className="cart-icon"
                        />
                        {getCartCount() > 0 && (
                          <span className="cart-count">{getCartCount()}</span>
                        )}
                      </Link>
                    )}

                    {/* AUTH AREA */}
                    {token ? (
                      <div className="user-menu">

                        {/* ACCOUNT BUTTON */}
                        <button
                          className="login user-trigger"
                          style={{ background: "none", border: "none", cursor: "pointer" }}
                        >
                          <i className="icofont-user"></i> ACCOUNT
                        </button>

                        {/* DROPDOWN */}
                        <div className="user-dropdown">
                          <p
                            className="dropdown-item"
                            onClick={() => this.context.navigate("/profile")}
                          >
                            My Profile
                          </p>
                          <p
                            className="dropdown-item"
                            onClick={() => this.context.navigate("/orders")}
                          >
                            Orders
                          </p>
                          <p
                            className="dropdown-item"
                            onClick={() => this.context.navigate("/cart-page")}
                          >
                            View Cart
                          </p>
                          <p
                            className="dropdown-item logout"
                            onClick={this.handleLogout}
                          >
                            Log Out
                          </p>
                        </div>

                      </div>
                    ) : (
                      <Link to="/login" className="login">
                        <i className="icofont-user"></i> LOG IN
                      </Link>
                    )}

                    {/* MOBILE MENU TOGGLE */}
                    <div className="header-bar d-lg-none" onClick={this.menuTrigger}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>

                  </div>

                  {/* MOBILE INFO TOGGLE */}
                  <div className="ellepsis-bar d-lg-none" onClick={this.menuTriggerTwo}>
                    <i className="icofont-info-square"></i>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </header>
    );
  }
}

Header.contextType = ShopContext;
export default Header;
